import { configureStore } from "@reduxjs/toolkit";

import authReducer from "@store/modules/auth";
import accountReducer from "@store/modules/account";

export default configureStore({
  reducer: {
    auth: authReducer,
    account: accountReducer,
  },
});
